import { render } from "./AppLayoutDefault.vue?vue&type=template&id=71b2c20a"
const script = {}
script.render = render

export default script